var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('BaseCard',{attrs:{"imageURL":"rux-how-to.jpg","linkURL":"https://rux.life/pages/how-to-rux/"}},[_vm._v(" how to rux")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }